import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import Header from "../../../components/header/Header";
import { selectedProject } from "../../home/appSlice/appslice";
import StudentDetailsContainer from "../container/studentDetailsContianer/StudentDetailsContainer";

const StudentDetailsPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const projectApp = useAppSelector(selectedProject)

  useEffect(() => {
    if (!projectApp) {
      navigate('/')
    }
  }, [projectApp])

  return (
    <>
      <Header title="student Details" />
      <StudentDetailsContainer id={id!} />
    </>
  )
}

export default StudentDetailsPage
